import { LOADING_SPINNER_COLOR } from '@/lib/loadingSpinnerColor';
import React from "react";
import { ActivityIndicator, StyleSheet, View } from "react-native";

const HALO = "rgba(0, 177, 118, 0.16)";
const HALO_LARGE = "rgba(0, 177, 118, 0.11)";

export type InlineBrandSpinnerProps = {
  size?: "small" | "large";
};

export function InlineBrandSpinner({ size = "small" }: InlineBrandSpinnerProps) {
  const isLarge = size === "large";
  return (
    <View
      style={[styles.halo, isLarge ? styles.haloLarge : styles.haloSmall]}
      accessibilityLabel="Loading"
      accessibilityRole="progressbar"
    >
      <ActivityIndicator size={size} color={LOADING_SPINNER_COLOR} />
    </View>
  );
}

const styles = StyleSheet.create({
  halo: {
    alignItems: "center",
    justifyContent: "center",
  },
  haloSmall: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: HALO,
  },
  haloLarge: {
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: HALO_LARGE,
  },
});
